import React from 'react';
import HeadersNonAuth from '../../components/base/HeadersNonAuth';

const HowToPlaceAnOptionsTradePage = () => {
  return (
    <div className="bg-[#0b0d2a] text-white font-sans">
      {/* Hero Section */}
      <HeadersNonAuth />
      <br />
      <br />
      <div
        className="h-[300px] bg-cover bg-center flex items-center justify-center"
        style={{
         backgroundImage: "url('/headers-landing.png')"
        }}
      >
        <h1 className="text-white text-4xl font-bold text-center px-4">
          How to Place an Options trade in <br /> TastyWorks, ThinkorSwim, RobinHood
        </h1>
      </div>

      {/* Links Section */}
      <div className="max-w-3xl mx-auto px-6 py-12 text-lg space-y-4">
        <p>
          <strong>i. Robinhood - </strong>
          <a
            href="https://robinhood.com/us/en/support/articles/placing-an-options-trade/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            https://robinhood.com/us/en/support/articles/placing-an-options-trade/
          </a>
        </p>
        <p>
          <strong>ii. Tastyworks - </strong>
          <a
            href="https://www.projectfinance.com/tastyworks-platform-trading/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            https://www.projectfinance.com/tastyworks-platform-trading/
          </a>
        </p>
      </div>
    </div>
  );
};

export default HowToPlaceAnOptionsTradePage;
